import type { AccountAction, AccountMenuProps } from 'shared-react/lumen';

export interface AccountMenuController {
  disableDemo?: () => void;
  enableDemo?: () => void;
  hotelOrMarket?: { hasRebranding: boolean };
  isDemoMode?: boolean;
  isMyHotels?: boolean;
  logout: () => void;
  openHelpCenter: () => void;
  redirectReferAFriend: () => void;
  redirectToAdmin?: () => void;
  redirectToAdminMarket?: () => void;
  redirectToAdminUser?: () => void;
  redirectToSubscription?: () => void;
}

export default function createAccountMenu(
  controller: AccountMenuController,
): Omit<AccountMenuProps, 'kind'> {
  return {
    hasRebranding: controller.hotelOrMarket?.hasRebranding,
    isDemoMode: controller.isDemoMode,
    isMyHotels: controller.isMyHotels,
    onAccountAction: (action: AccountAction): void => {
      switch (action) {
        case 'help':
          controller.openHelpCenter();
          break;
        case 'logout':
          controller.logout();
          break;
        case 'refer-a-friend':
          controller.redirectReferAFriend();
          break;
        case 'admin':
          controller.redirectToAdmin?.();
          break;
        case 'admin-subscription':
          controller.redirectToSubscription?.();
          break;
        case 'admin-market':
          controller.redirectToAdminMarket?.();
          break;
        case 'admin-user':
          controller.redirectToAdminUser?.();
          break;
        case 'toggle-demo':
          if (controller.isDemoMode) {
            controller.disableDemo?.();
          } else {
            controller.enableDemo?.();
          }
          break;
      }
    },
  };
}
